<template>
    <div class="notification-banner" :class="notification.type">
        <div class="notification-details">
            <div class="notification-icon">
                <div class="notification-image-wrapper">
                    <div class="notification-image" v-bind:style="{ 'background-image': `url(${ notification.iconUrl })`, 'background-size': notification.isIconSvg ? 'contain' : 'cover' }"></div>
                </div>
                <div class="sub-icon success-sub-icon" v-if="notification.subIcon == 'success'"><check-mark-svg></check-mark-svg></div>
                <div class="sub-icon warning-sub-icon" v-if="notification.subIcon == 'warning'"><warning-svg></warning-svg></div>
            </div>
            <div class="notification-message" v-html="notification.message"></div>
        </div>
        <div class="notification-controls">
            <a v-if="notification.link" :href="notification.link" target="_blank" class="notification-action" size="small"><strong class="blue-accent">{{ notification.actionLabel }}</strong></a>
            <app-button class="notification-action" 
                v-if="notification.actionLabel && secondsLeft > 0 && !notification.link" 
                size="small" 
                :onClick="notification.action" 
                :class="{ 'undo-action': notification.actionLabel == 'Undo' }">
                <span>
                    <span class="timer">{{ secondsLeft }}</span>
                    <span class="action-label">{{ notification.actionLabel }}</span>
                </span>
            </app-button>
            <button class="notification-close-button" @click="close">×</button>
        </div>
    </div>
</template>

<script>
import EventBus from '@/scripts/event-bus';
import CheckMarkSvg from '@/components/svg/checkmark-svg';
import WarningSvg from '@/components/svg/warning-svg';
import AppButton from '@/components/common/app-button';

export default {
    props: ['notification'],

    components: {
        'warning-svg': WarningSvg,
        'check-mark-svg': CheckMarkSvg,
        'app-button': AppButton
    },

    data: function () {
        return {
            secondsLeft: 10,
            timer: null
        };
    },

    methods: {
        close() {
            EventBus.$emit('close-notification', this.notification);
        },

        countdown() {
            if(this.secondsLeft >= 1) {
                this.secondsLeft--;
            } else {
                this.secondsLeft = 0;
                clearInterval(this.timer);
            }
        }
    },
    
    mounted() {
        setTimeout(() => {
            this.close();
        }, 10000);
    },

    created () {
        if (this.notification.actionLabel == 'Undo') {
            this.timer = setInterval(() => this.countdown(), 1000);
        }
    }
}
</script>

<style>
.notification-banner {
    position: fixed;
    top: 15px;
    left: 50%;
    margin-left: -321px;
    min-height: 52px;
    width: 643px;
    border-radius: 502px;
    border: 1px solid var(--color-border-accent-brightgray);
    background: var(--color-background-secondary);
    z-index: 100000;
    box-shadow: 0px 3px 6px rgba(135, 125, 136, 0.7);
    display: flex;
    justify-content: space-between;
    /* border: 1px solid #000; */
}

.notification-banner .notification-details {
    display: flex;
    align-items: center;
    margin-left: 2px;
}

.notification-banner .notification-icon {
    position: relative;
}

.notification-banner .sub-icon {
    position: absolute;
    bottom: 0;
    right: 0;
}

.notification-banner .success-sub-icon {
    right: -5px;
}

.notification-banner .success-sub-icon {
    bottom: -7px;
    right: -8px;
    width: 25px;
}

.notification-banner .warning-sub-icon {
    bottom: -7px;
    right: -4px;
}

.notification-banner .notification-image-wrapper {
    border-radius: 50%;
    width: 46px;
    height: 46px;
    overflow: hidden;
}

.notification-banner .notification-image-wrapper .notification-image {
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50%;
    max-width: 30px;
    margin: 0 auto;
}

.notification-banner .notification-message {
    text-align: left;
    margin-left: 20px;
}

.notification-banner.fail .notification-message,
.notification-banner.fail strong  {
    color: var(--color-text-warning);
}

.notification-banner .success-sub-icon path {
    stroke: var(--color-icon-white);
    stroke-width: 1px;
}

.notification-banner .notification-controls {
    display: flex;
    align-items: center;
    margin-right: 2px;
}

.notification-banner .notification-action {
    background: transparent;
    border: none;
    outline: none;
    color: var(--color-text-link);
    font-size: 16px;
    line-height: 19px;
    margin-right: 10px;
}

/*Unknown Schema Requirement*/
.notification-banner .notification-action:hover {
    background: #DBEDFA;
}

.notification-banner .notification-action .action-label {
    font-size: 16px;
    line-height: 19px;
}

.notification-banner .notification-action .action-label {
    font-weight: normal;
}

.notification-banner .notification-close-button {
    background: transparent;
    border: none;
    font-size: 24px;
    font-weight: 600;
    color: var(--color-text-accent-vividraspberry);
    height: 44px;
    width: 44px;
    border-radius: 50%;
}

/*Unknown Schema Requirement*/
.notification-banner .notification-close-button:hover {
    background: #F5D5E7;
}

.notification-banner .notification-close-button:focus {
    border: none;
    outline: 0;
}

.notification-banner .timer {
    display: none;
}

/*Unknown Location*/
.notification-banner .undo-action {
    top: 7px;
    height: 37px;
    width: 150px;
    border: 2px solid var(--color-border-accent-skyblue-base);
    border-radius: 37px; 
    text-align: right;
    padding: 0 17px;
    line-height: 17px;
}

/*Unknown Location*/
.notification-banner .undo-action:hover {
    background: var(--color-fill-accent-skyblue);
    color: var(--color-text-inverse);
}

.notification-banner .undo-action .action-label {
    float: right;
}

.notification-banner .undo-action .timer {
    display: initial;
    float: left;
}

/*Unknown Schema Requirement*/
.notification-banner .blue-accent {
    color: #1fa2ff;
}

.under-review.page .notification-banner {
    top: 50px;
}
</style>